
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { CustomerModel } from '@models/customer';
import { OrderIdsModel } from '@models/orderIds-model';
import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from '@shared/app-state';

@Component({
    selector: 'app-order-chooser',
    templateUrl: './order-chooser.component.html',
    styleUrls: ['./order-chooser.component.scss'],
    imports: [TranslatePipe, ButtonComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class OrderChooserComponent implements OnChanges {
	@Input() customer: CustomerModel | null;
	@Output() orderIdChange = new EventEmitter<number | null>();
	public isReady: boolean;
	public get orderIds(): Array<OrderIdsModel> {
		return this.appState.orderIds;
	}

	constructor(private appState: AppState) { }

	async ngOnChanges(changes: SimpleChanges) {
		this.isReady = true;
	}

	async onOrderChosen(orderId: number | null) {
		const newOrderId = orderId;
		this.orderIdChange.next(newOrderId);
	}

	cancel() {
		this.orderIdChange.next(null);
	}

	getOrderName(order: OrderIdsModel, index: number): number {
		const name = order.AxId > 0 ? order.AxId : index + 1;
		return name;
	}
}
